jQuery(document).ready(function ($) {
    if($('body').hasClass('page-template-page-landing')){
        // Slider
        $('.lifestyle__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            dots: false,
            arrows: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                },
            ]
        });

        // Highlight pins on hover
        $('.lifestyle__slide-products-item').hover(function() {
            var count = $(this).attr('data-count');
            
            // Toggle active class on internal pin
            $(this).find('.lifestyle__slide-pin').toggleClass('lifestyle__slide-pin--active');

            // Find pin on image
            $('.lifestyle__slide-image').find(".lifestyle__slide-pin[data-highlight='" + count + "']").toggleClass('lifestyle__slide-pin--active');
        });

        // Products carousel
        $('.carousel__products').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 552,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

    }
});